export const COMMON_LINKS = {
  legal_kitz_book_call_link:
    'https://legalkitz.com.au/book-a-consultation/?utm_source=app-homepage&utm_medium=homepage+tile&utm_campaign=book-a-call&utm_id=referral-app-book-call',
};
